<template>
  <div>
    <!-- 申报审核头部 -->
    <a-affix @change="changeAffix" :offset-top="70" class="affix">
      <div
        v-if="bfStateName == 'EMPLOYERS_REVIEW' && $route.query?.activeNum"
        class="top"
      >
        <div class="btns">
          <ComActionButton @click="pass" text="审核通过"></ComActionButton>
          <ComActionButton @click="reject" text="审核不通过"></ComActionButton>
          <ComActionButton
            @click="returnUpdate"
            text="返回修改"
          ></ComActionButton>
          <ComActionButton @click="turnDrafts" text="暂存"></ComActionButton>
        </div>
        <a-textarea
          v-model="message"
          style="margin-top: 12px"
          placeholder="高校科研A类：博士后出站于（）的（）专业，博士毕业于（）的（）专业，（符合或不符合）选拔公告要求；本科、硕士等条件（符合或不符合）选拔公告要求，审核（通过或不通过）。其他：博士毕业于（）的（）专业，本科、硕士等条件（符合或不符合）选拔公告要求，审核（通过或不通过）。"
          :rows="rows"
        />
        <a-upload
          v-if="showFileList"
          name="file"
          :accept="accept"
          :default-file-list="fileList"
          :headers="headers"
          :action="actionPath"
          :before-upload="beforeUpload"
          @change="handleChangeUpload"
        >
          <div class="upload-btn pointer">
            <a-icon type="upload" />&nbsp;上传附件
          </div>
        </a-upload>
      </div>
    </a-affix>
    <a-affix @change="changeAffix" :offset-top="70" class="affix">
      <div
        v-if="
          bfStateName == 'EMPLOYERS_MATERIALS_REVIEW' &&
          $route.query?.activeNumFile
        "
        class="top"
      >
        <div class="btns">
          <ComActionButton
            @click="batchPass(1)"
            text="审核通过"
          ></ComActionButton>
          <ComActionButton
            @click="batchPass(2)"
            text="审核不通过"
          ></ComActionButton>
          <ComActionButton
            @click="batchPass(3)"
            text="返回修改"
          ></ComActionButton>
          <ComActionButton @click="batchPass(4)" text="暂存"></ComActionButton>
        </div>
        <a-textarea
          v-model="messageFile"
          style="margin-top: 12px"
          placeholder="请输入意见"
          :rows="rows"
        />
        <a-upload
          v-if="showFileListFile"
          name="file"
          :accept="accept"
          :default-file-list="fileListFile"
          :headers="headers"
          :action="actionPath"
          :before-upload="beforeUpload"
          @change="handleChangeUploadFile"
        >
          <div class="upload-btn pointer">
            <a-icon type="upload" />&nbsp;上传附件
          </div>
        </a-upload>
      </div>
    </a-affix>

    <!-- 批量审核模态框 -->
    <a-modal
      ok-text="提交"
      title="返回修改时限设置"
      :visible="visible"
      width="780px"
      @ok="confirm"
      @cancel="cancelFn"
      destroyOnClose
    >
      <div>
        <a-radio-group v-model="valueRadio">
          <a-radio :value="1"> 不设置时限 </a-radio>
          <br />
          <br />
          <a-radio :value="2"> 设置时限 </a-radio>
        </a-radio-group>
        <a-date-picker
          @ok="choseTime"
          format="YYYY-MM-DD HH:mm:ss"
          :disabled-date="disabledDate"
          :show-time="{ defaultValue: moment('00:00:00', 'HH:mm:ss') }"
        />
      </div>
    </a-modal>
  </div>
</template>

<script>
//   申诉意见

import { batchInterview } from "@/api/offlineInspection";
import { _ctxPath, _accept } from "@/api/http";
import {
  pass,
  reject,
  returnUpdate,
  turnDraft,
  batchMaterial,
  stagingMaterial,
  stagingDisplay,
} from "@/api/declaration.js";
import { selectApplyInforma } from "@/api/userInfo";
import moment from "moment";
import "moment/locale/zh-cn";
import ComActionButton from "@/components/common/buttons/com-action-button.vue";
export default {
  name: "DeclareCheck",
  components: {
    ComActionButton,
  },
  props: ["talentDiff", "bfStateName"],
  data() {
    return {
      showFileList: false,
      showFileListFile: false,
      // bfStateName: '',
      rows: 2,
      time: "",
      // talentDiff: {},
      fileList: [],
      fileListFile: [],
      attachment: [],
      attachmentFile: [],
      message: "",
      messageFile: "",
      valueRadio: 1,
      moment,
      visible: false,
      columns: [
        {
          title: "相关信息",
          dataIndex: "name",
          key: "name",
          width: 470,
          ellipsis: true,
        },
        {
          title: "岗位要求",
          dataIndex: "age",
          key: "age",
          width: 470,
          ellipsis: true,
        },
        {
          title: "是否通过",
          dataIndex: "address",
          key: "address",
          width: 158,
          scopedSlots: { customRender: "address" },
          ellipsis: true,
        },
      ],
      columnsDegree: [
        {
          title: "学历",
          dataIndex: "name",
          key: "name",
          width: 150,
          ellipsis: true,
        },
        {
          title: "毕业院校及院系",
          dataIndex: "age",
          key: "age",
          width: 460,
          ellipsis: true,
        },
        {
          title: "标题",
          dataIndex: "address",
          key: "address",
          width: 460,
          ellipsis: true,
        },
      ],
    };
  },
  computed: {
    accept() {
      return _accept;
    },
    actionPath() {
      return _ctxPath + "/xmt/file/upload";
    },
    headers() {
      return {
        Authorization: "Bearer " + this.$store.getters.token,
      };
    },
  },

  mounted() {
    if (this.$route.path.includes("institution")) {
      this.init();
    }
  },

  methods: {
    init() {
      let that = this;
      // 回显审核意见和附件
      selectApplyInforma({ id: this.$route.query.id }).then((res) => {
        // console.log("selectApplyInforma", res);
        if (res.code == 0 && res?.data?.length) {
          res.data.forEach((element) => {
            if (element.draft == 1 && element.processStatus == "用人单位审核") {
              that.message = element.opinionContent;
              if (element.attachment) {
                JSON.parse(element.attachment).forEach((item, index) => {
                  that.fileList.push({
                    storageKey: item.storageKey,
                    name: item.fileName,
                    uid: index,
                  });
                  this.attachment.push(item.storageKey);
                });
              }
            }
          });
        }
        this.showFileList = true;
      });
      // 回显审核意见和附件
      stagingDisplay({ id: this.$route.query.id }).then((res) => {
        console.log("stagingDisplay", res);
        if (res.code == 0 && res?.data) {
          that.messageFile = res?.data.detail;
        }
        if (res.code == 0 && res?.data?.atts?.length) {
          res?.data?.atts.forEach((item, index) => {
            that.fileListFile.push({
              storageKey: item.storageKey,
              name: item.fileName,
              uid: index,
            });
            this.attachmentFile.push(item.storageKey);
          });
        }
        this.showFileListFile = true;
      });
    },

    // 批量更新材料审核
    batchPass(num) {
      if (!this.messageFile && num !== 4) {
        this.$message.warning("请填写审核意见");
        return;
      }
      this.attachmentFile = this.attachmentFile.join(",");
      let params = {
        vo: {
          ids: [this.$route.query.id],
          detail: this.messageFile,
          att: this.attachmentFile,
          isPass: num,
        },
        talentDiffVo: { ...this.talentDiff },
      };
      console.log("params", params);
      // 暂存
      if (num == 4) {
        params = {
          id: this.$route.query.id,
          detail: this.messageFile,
          att: this.attachmentFile,
        };
        // 暂存
        stagingMaterial(params).then((res) => {
          // console.log(res);
          if (res.code == 0) {
            this.$message.success("操作成功");
          } else {
            this.$message.error("操作失败");
          }
          this.$router.push("/institution/declare-files-list");
        });
      } else {
        batchMaterial(params).then((res) => {
          // console.log(res);
          if (res.code == 0) {
            this.$message.success("操作成功");
          } else {
            this.$message.error("操作失败");
          }
          this.$router.push("/institution/declare-files-list");
        });
      }
    },
    // 批量更新初面结果
    batchInterview(num) {
      console.log(
        this.$refs.comOneCheck.attachment,
        this.$refs.comOneCheck.message
      );
      let ids = [this.$route.query.id]; //数据id数组
      let params = {
        address: this.address,
        atts: this.$refs.comOneCheck.attachment.join(","),
        ids,
        inspectDate: this.time,
        opinion: this.$refs.comOneCheck.message,
        whethePass: num,
      };
      console.log("params", params);
      let routeUrl = `/institution/declare-files-list`;
      batchInterview(params)
        .then((res) => {
          // console.log(res);
          if (res.code == 0) {
            this.$message.success("操作成功");
          } else {
            this.$message.error("操作失败");
          }
        })
        .finally(() => {
          this.$router.push(routeUrl);
        });
    },
    // 审核通过
    // 获取数据
    pass() {
      // this.attachment = []
      // this.fileList.forEach(element => {
      //   this.attachment.push(element.attachment)
      // });
      if (!this.message) {
        this.$message.warning("请填写审核意见");
        return;
      }
      this.attachment = this.attachment.join(",");
      this.attachment = btoa(this.attachment);
      let params = {
        id: this.$route.query.id,
      };
      pass(params, {
        ...this.talentDiff,
        opinionContent: this.message,
        opinionAttachments: this.attachment,
      }).then((res) => {
        console.log(res);
        if (res.code == 0) {
          this.$message.success("操作成功");
        } else {
          this.$message.error("操作失败");
        }

        this.$router.push("/institution/declare-list");
      });
    },
    // 审核不通过
    reject() {
      if (!this.message) {
        this.$message.warning("请填写审核意见");
        return;
      }
      this.attachment = this.attachment.join(",");
      this.attachment = btoa(this.attachment);
      let params = {
        id: this.$route.query.id,
      };
      // if (this.message) {
      reject(params, {
        ...this.talentDiff,
        opinionContent: this.message,
        opinionAttachments: this.attachment,
      }).then((res) => {
        console.log(res);
        if (res.code == 0) {
          this.$message.success("操作成功");
        } else {
          this.$message.error("操作失败");
        }
        this.$router.push("/institution/declare-list");
      });
    },
    // 返回修改
    returnUpdate() {
      if (!this.message) {
        this.$message.warning("请填写审核意见");
        return;
      }
      this.attachment = this.attachment.join(",");
      this.attachment = btoa(this.attachment);
      console.log(this.time, this.valueRadio);
      let params = {
        id: this.$route.query.id,
      };
      returnUpdate(params, {
        ...this.talentDiff,
        opinionContent: this.message,
        opinionAttachments: this.attachment,
      }).then((res) => {
        console.log(res);
        if (res.code == 0) {
          this.$message.success("操作成功");
        } else {
          this.$message.error("操作失败");
        }
        this.$router.push("/institution/declare-list");
      });
    },
    // 暂存
    turnDrafts() {
      this.attachment = this.attachment.join(",");
      this.attachment = btoa(this.attachment);
      let params = {
        id: this.$route.query.id,
      };
      turnDraft(params, {
        ...this.talentDiff,
        opinionContent: this.message,
        opinionAttachments: this.attachment,
      }).then((res) => {
        console.log(res);
        if (res.code == 0) {
          this.$message.success("操作成功");
        } else {
          this.$message.error("操作失败");
        }
        this.$router.push("/institution/declare-list");
      });
    },
    handleChangeUpload(file) {
      const { fileList } = file;
      this.attachment = [];
      let spliceIndex = -1;
      fileList.forEach((item, index) => {
        const res = item.response;
        if (res?.code === 200) {
          this.attachment.push(res.data[0].storageKey);
        } else if (res?.code === 500) {
          this.$message.error(res.msg);
          spliceIndex = index;
        } else if (item.storageKey) {
          this.attachment.push(item.storageKey);
        }
      });
      if (spliceIndex > -1) {
        fileList.splice(spliceIndex, 1);
      }
      this.fileList = fileList;
      console.log("this.fileList", this.fileList);
    },
    handleChangeUploadFile(file) {
      const { fileList } = file;
      this.attachmentFile = [];
      let spliceIndex = -1;
      fileList.forEach((item, index) => {
        const res = item.response;
        if (res?.code === 200) {
          this.attachmentFile.push(res.data[0].storageKey);
        } else if (res?.code === 500) {
          this.$message.error(res.msg);
          spliceIndex = index;
        } else if (item.storageKey) {
          this.attachmentFile.push(item.storageKey);
        }
      });
      if (spliceIndex > -1) {
        fileList.splice(spliceIndex, 1);
      }
      this.fileListFile = fileList;
      console.log("this.fileListFile", this.fileListFile);
    },
    beforeUpload(file) {
      const isLt50M = file.size / 1024 / 1024 < 50;
      if (!isLt50M) {
        this.$message.error("请上传小于50MB的文件!");
      }
      return isLt50M;
    },
    range(start, end) {
      const result = [];
      for (let i = start; i < end; i++) {
        result.push(i);
      }
      return result;
    },
    disabledDate(current) {
      // Can not select days before today and today
      return current && current < moment().endOf("day");
    },

    choseTime(e) {
      console.log(this.$moment(e).format("YYYY-MM-DD HH:mm:ss"));
      this.time = this.$moment(e).format("YYYY-MM-DD HH:mm:ss");
    },
    open() {
      console.log(this.attachment);
      this.visible = true;
    },
    confirm() {
      console.log(this.valueRadio);
      this.returnUpdate();
      this.visible = false;
    },
    cancelFn() {
      this.visible = false;
    },
    changeAffix(affixed) {
      if (affixed) {
        this.rows = 1;
      } else {
        this.rows = 2;
      }
      this.$emit("changeAffix", affixed);
    },
  },
};
</script>
<style lang="less" scoped>
.com-progress {
  padding: 16px 16px;
  background: #fff;
}

::v-deep {
  .ant-input {
    border: none;
    background-color: #f1f5f8;
  }
  textarea.ant-input {
    border: 4px solid #f0f8ff;
    background: #f9fafb;
    resize: none;
  }

  .ant-table-thead > tr > th {
    background: #f1f5f9;
  }

  .ant-table-thead > tr > th,
  .ant-table-tbody > tr > td {
    padding: 12px 12px;
  }

  .ant-table-thead > tr > th {
    color: #505d6e;
    font-size: 14px;
    font-weight: 500;
    font-family: "PingFang SC";
  }

  .ant-table-tbody > tr > td {
    color: #111111;
    font-size: 14px;
    font-weight: 400;
    font-family: "PingFang SC";
  }

  .ant-select {
    color: #111111;
    font-size: 12px;
    font-weight: 400;
    font-family: "PingFang SC";
    text-align: left;
  }

  .ant-select-selection {
    background: #f1f5f8;
    border: none;
    text-align: left;
    text-indent: 0;
  }

  .ant-select-selection--single {
    height: 30px;
  }

  .ant-select-selection--single .ant-select-selection__rendered {
    margin-right: 0;
  }

  .affix {
    margin-top: 24px;
  }

  .com-main-container-content {
    margin: 0px auto 36px;
  }

  .top {
    margin-top: 0px;
    box-shadow: 0 6px 30px 5px #0000000d, 0 16px 24px 2px #0000000a,
      0 8px 10px -5px #00000014;
  }
}
.smallHeight {
  margin-top: 0px;
}
.normalHeight {
  margin-top: 20px;
}
</style>
